/** Tiny subsequence fuzzy scorer for palette commands. Higher is better; -1 = no match. */
export function fuzzyScore(query: string, target: string): number {
  const q = query.toLowerCase();
  const t = target.toLowerCase();
  if (!q) return 0;
  if (t.includes(q)) return 100 - t.indexOf(q) - (t.length - q.length) * 0.1;
  let qi = 0;
  let score = 0;
  let streak = 0;
  for (let i = 0; i < t.length && qi < q.length; i++) {
    if (t[i] === q[qi]) {
      qi++;
      streak++;
      score += streak * 2 + (i === 0 || /[\s\-_/]/.test(t[i - 1]) ? 5 : 0);
    } else streak = 0;
  }
  return qi === q.length ? score : -1;
}
